import React, { useCallback, useState, useMemo, useEffect } from 'react';

import { connect } from 'react-redux';
import * as fromApp from '../../store/app';

import ToolbarNavigationView from './ToolbarNavigation.view';

import ruFlag from 'assets/images/langs/ru-lang.png';
import caFlag from 'assets/images/langs/usa-ca-lang.png';
import usaFlag from 'assets/images/langs/usa-lang.png';
import ilFlag from 'assets/images/langs/il-lang.png';
import frFlag from 'assets/images/langs/fr-lang.png';

import { ILang } from 'app/ui/MToolbar/MToolbar.model';
import { ISpecs } from 'app/models/specs/specs';
import { useNavigate } from 'react-router-dom';
import { Clients } from 'app/enums/clients';
import { LocalStorage } from '../../constants/StorageConstants';
import { ISupplier } from 'app/models/supplier';
import { useTranslation } from 'react-i18next';

interface PropsFromState {
  specs: ISpecs | null;
  client: Clients | null;
  supplier: ISupplier | null;
  languagesFlag: boolean;
}

interface Props extends PropsFromState { }

const ToolbarNavigation: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {

  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const [popupCreateAccountState, setPopupCreateAccountState] = useState<boolean>(false);
  const [currentLanguageState, setcurrentLanguageState] = useState<ILang | null>(null);

  const languages: ILang[] = useMemo(() => {
    const lang = [
      {
        label: 'Français',
        value: 'fr',
        image: frFlag,
      },
      {
        label: 'English',
        value: 'en',
        image: usaFlag,
      },
      {
        label: 'English',
        value: 'en-ca',
        image: caFlag,
      },
      {
        label: 'Русский',
        value: 'ru',
        image: ruFlag,
      },
      {
        label: 'עברית',
        value: 'he',
        image: ilFlag,
      },
    ];

    const languages: ILang[] = lang.filter((lang: ILang) => props.specs?.languages.includes(lang.value));
    if (languages.length > 0) {
      const defaultLang = props.specs?.languages[0]; // the default language is first on list of specs
      const language = languages.find((language: ILang) => language.value === defaultLang);

      if (language) {
        setcurrentLanguageState(() => language);
      }
    }
    return languages;
  }, [props.specs?.languages, i18n.changeLanguage, setcurrentLanguageState]);

  useEffect(() => {
    i18n.changeLanguage(currentLanguageState?.value);
  },[currentLanguageState]);

  const onChangelanguage = useCallback(
    (selectedValue: string) => {
      const lang = languages.find((lang: ILang) => lang.value === selectedValue);
      if (lang) {
        setcurrentLanguageState(() => lang);
        i18n.changeLanguage(lang.value);
      }
    },
    [currentLanguageState, languages, props.specs?.languages, i18n, setcurrentLanguageState],
  );

  const logoClickHandler = () => {
    sessionStorage.clear();
    navigate(`/?client=${localStorage.getItem(LocalStorage.Client)}&supplier=${props.supplier?.name}`);
  };

  return (
    <ToolbarNavigationView
      languages={languages}
      languagesFlag={props.languagesFlag}
      currentLanguageState={currentLanguageState}
      popupCreateAccountState={popupCreateAccountState}
      onChangelanguage={onChangelanguage}
      onClosePopupCreateAccount={() => setPopupCreateAccountState(() => false)}
      onOpenPopupCreateAccount={() => setPopupCreateAccountState(() => true)}
      onLogoClick={logoClickHandler}
    ></ToolbarNavigationView>
  );
};

ToolbarNavigation.displayName = 'ToolbarNavigation';
ToolbarNavigation.defaultProps = {};

const mapStateToProps = (state: fromApp.AppState): PropsFromState => {
  return {
    specs: state.settings.specs,
    client: state.settings.specs?.client || null,
    supplier: state.settings.supplierDetails,
    languagesFlag: state.settings.specs?.languagesFlag || false,
  };
};

export default connect(mapStateToProps)(ToolbarNavigation);
